import React from "react";
import "./../../Assets/CSS/scriptinject.css"
import ScriptInjectBanner from "./ScriptInjectBanner";
import ScriptInjectPage from "./Services";

export default function ScriptInjectHome() {
  return (
    <>
      <title>ScriptInject™ | ScriptSite RX</title>
      <ScriptInjectBanner />
      <ScriptInjectPage />
    </>
  );
}
